import React from 'react';

function BrandNoveltyCard({item, buttonTitle}) {
  return (
    <div className="relative flex min-h-[210px] h-full items-center overflow-hidden rounded-[12px] bg-[#F8F3FF]">
      <div className="relative z-[2] flex h-full max-w-[58%] flex-col items-start py-[20px] pl-[20px] 500:py-[12px] 500:pl-[12px]">
        <a href={item.url} className="border-b border-l-0 border-t-0 border-r-0 border-solid border-transparent pb-[2px] hover:border-black">
          <h3 className="m-0 text-[20px] font-semibold leading-normal text-[#000] 500:text-[16px]">
            {item.title}
          </h3>
        </a>
        {item.description && (
          <p className="mb-[12px] mt-[6px] whitespace-pre-line text-[13px] leading-normal text-[#000] 500:text-[12px]">
            {item.description}
          </p>
        )}
        <a
          href={item.url}
          className="mt-auto inline-flex items-center justify-center rounded-[14px] bg-blue-primary hover:bg-blue-hover py-[14px] px-[24px] text-[14px] text-white font-medium leading-normal 500:w-[90%]"
        >
          {buttonTitle}
        </a>
      </div>
      {item.image?.src && (
        <a href={item.url} className="flex w-[42%]">
          <picture>
            {item.image.avif && <source srcSet={item.image.avif} type="image/avif"/>}
            {item.image.webp && <source srcSet={item.image.webp} type="image/webp"/>}
            <img
              src={item.image.src}
              alt={item.title || ''}
              width={item.image.width}
              height={item.image.height}
              loading="lazy"
              decoding="async"
              className="h-full w-full object-contain object-bottom"
            />
          </picture>
        </a>
      )}
    </div>
  );
}

export default BrandNoveltyCard;